var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.667,
    height: 1.846,
    x: 6.666,
    y: 8,
    fill: "currentColor",
    rx: 0.923
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.667,
    height: 1.846,
    x: 6.666,
    y: 11.078,
    fill: "currentColor",
    rx: 0.923
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.667,
    height: 1.846,
    x: 6.666,
    y: 14.152,
    fill: "currentColor",
    rx: 0.923
  })));
};
export { SvgMenu as ReactComponent };